import { Button, Input } from '@triumph/design-system';
import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useApplicantQuery } from '@/components/shared/api/queries/applicant';
import { NoMarginParagraph } from '@/components/shared/components/LabelValuePair/LabelValuePair.StyledComponents';

import {
    ContentWrapper,
    InputButtonWrapper,
    LoggiedInMessage,
    Wrapper,
} from './Home.StyledComponents';

export const Home = () => {
    const navigate = useNavigate();

    const [applicantId, setApplicantId] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const {
        isFetching: isApplicantDataFetching,
        error,
        refetch,
    } = useApplicantQuery({
        applicantId: applicantId,
        retry: 0,
        enabled: false,
    });

    useEffect(() => {
        if (error && applicantId && error.status) {
            switch (error.status) {
                case 400:
                    setErrorMessage(`The AppID ${applicantId} is not valid.`);
                    break;
                case 413:
                    setErrorMessage(`The AppID ${applicantId} entity is too large.`);
                    break;
                case 404:
                case 500:
                    setErrorMessage(`The AppID ${applicantId} wasn't found.`);
                    break;
            }
        }
    }, [error, applicantId]);

    const handleApplicantIdChange = (e: ChangeEvent<HTMLInputElement>) => {
        setApplicantId(e.target.value);
    };

    const handleOpenApplicantClick = async (e: FormEvent) => {
        e.preventDefault();
        if (!applicantId) return;

        const result = await refetch();
        if (result.status === 'success' && result.data) {
            navigate(`/applicant/${result.data.id}`);
        }
    };

    return (
        <Wrapper>
            <ContentWrapper>
                <div>
                    {errorMessage ? (
                        <NoMarginParagraph>{errorMessage}</NoMarginParagraph>
                    ) : (
                        <>
                            <LoggiedInMessage>Thanks, you're now logged in.</LoggiedInMessage>
                            <NoMarginParagraph>
                                You can now open direct links from <b>Salesforce</b> or <b>Slack</b>
                                .
                            </NoMarginParagraph>
                        </>
                    )}
                </div>
                <form onSubmit={handleOpenApplicantClick}>
                    <InputButtonWrapper>
                        <Input
                            id="app-id"
                            onChange={handleApplicantIdChange}
                            name="applicantId"
                            labelText="Applicant ID"
                        />
                        <Button loading={isApplicantDataFetching} type="submit">
                            Open Applicant
                        </Button>
                    </InputButtonWrapper>
                </form>
            </ContentWrapper>
        </Wrapper>
    );
};
